<h1 mat-dialog-title>El usuario ya se encuentra registrado</h1>
<div mat-dialog-content>El usuario ya fue registrado con anterioridad. 
    <p>¿Deseas perfilarlo para repetir los exámenes?</p>
    <p>Antes de aceptar verifica que los datos como Nombre y CURP se encuentren correctos</p>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close style="background-color: rgba(0, 191, 255, 0.869);">Cerrar</button>
    <button mat-button style="background-color: rgba(255, 82, 82, 0.655);" (click)="accept()">Aceptar</button>
</div>
